import { Box, CircularProgress, Container, Fade } from "@mui/material";
import { Navigate, Route, Routes, useNavigate } from "react-router"
import { SlideInContextProvider } from "../../context/SlideInContext";
import SlideIn from "../components/SlideIn";
import AppBar from "../components/AppBar";
import { StudentLinkPage, StudentManagePage } from ".";
import { SelectedStudentProvider, useSelectedStudent } from "./hooks";
import { ViewAllStudents } from "./ViewAllStudents";
import StudentNoteTablePage from "./StudentNotePage";
import TransferStudentLocationPage from "./TransferStudentLocationPage";
import { ManageModal, ManageModalProvider } from "ui";

const StudentManagementRoutes = () => {
    const navigate = useNavigate();

    return (
        <Routes>
            <Route index element={<ViewAllStudents onBack={() => navigate(-1)} />} />
            <Route path="details/:sid" element={(
                <StudentManagePage
                    onLink={(id) => navigate(`/manage/children/link/${id}`)}
                    onBack={() => navigate(-1)} />
            )} />
            <Route path="location/:sid" element={<TransferStudentLocationPage onBack={() => navigate(-1)} />} />
            <Route path="notes/:sid" element={<StudentNoteTablePage onBack={() => navigate(-1)} />} />
            <Route path="link/:sid" element={<StudentLinkPage onBack={() => navigate(-1)} />} />
            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    )
}


export const StudentIndexPage = () => {

    const loading = false;

    return (
        <Fade in={true}>
            <Box component="div">
                <SlideInContextProvider>
                    <ManageModalProvider>
                        <div>
                            <SlideIn />
                            <AppBar />
                            <ManageModal />
                        </div>
                        <Container maxWidth="xl">
                            <Box
                                component="div"
                                sx={{ paddingTop: "40px", paddingBottom: "32px" }}
                            >
                                {loading ? (
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "50vh",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <SelectedStudentProvider>
                                        <StudentManagementRoutes />
                                    </SelectedStudentProvider>
                                )}
                            </Box>
                        </Container>
                    </ManageModalProvider>
                </SlideInContextProvider>
            </Box>
        </Fade>
    )
}